export default __webpack_public_path__ + "static/results-3d8dbb68c7e27c2bd080bcaee60f5599.png";